<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <div class="row mb-2">
      <div class="col-12 text-end">
        <button class="btn btn-custom btn-success" (click)="add()" type="button">
          <i class="bi bi-plus-circle-fill me-2"></i>เพิ่ม</button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-borderless caption-top">
        <thead>
        <tr>
          <th nowrap scope="col">ลำดับ</th>
          <th nowrap scope="col">วันที่สร้าง</th>
          <th nowrap scope="col">User ID</th>
          <th nowrap scope="col">เลขประจำตัวประชาชน</th>
          <th nowrap scope="col">ชื่อ-สกุล</th>
          <th nowrap scope="col">วันที่อัปเดต</th>
          <th nowrap scope="col">วันที่หมดอายุ</th>
          <th nowrap class="text-center" scope="col">สถานะ</th>
          <th nowrap class="text-center" scope="col">ต่ออายุ</th>
        </tr>
        </thead>
        <tbody>
          @for (item of pageData?.content; let i = $index; track item.id) {
            <tr>
              <td nowrap>{{ (pageData.size * pageData.number) + (i + 1) }}</td>
              <td>{{ item.createdDate | thaidatetime }}</td>
              <td>{{ item.id }}</td>
              <td>{{ item.personalId }}</td>
              <td>{{ item.personalDataFirstName + ' ' + item.personalDataLastName }}</td>
              <td>{{ item.lastUpdatedDate | thaidatetime }}</td>
              <td>{{ item.expiredDate | thaidatetime }}</td>
              <td class="text-center">
                <small [ngClass]="{'text-success bg-success border-success' : item.tokenAvailable === 'VALID',
                'text-danger bg-danger border-danger' : item.tokenAvailable == 'EXPIRED',
                'text-warning bg-warning border-warning' : item.tokenAvailable == 'CLOSE_TO_EXPIRATION'}"
                  class="d-inline-flex px-2 py-1 fw-semibold  bg-opacity-10 border border-opacity-10 rounded-2">
                  {{TokenType[item.tokenAvailable]}}
                </small>
              </td>
              <td nowrap class="text-center">
                @if(principal?.userId === item.id){
                  <button class="btn btn-custom btn-warning" (click)="add()" type="button">
                    <i class="bi bi-arrow-repeat me-2"></i>ต่ออายุ</button>
                }
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="10">
                <app-not-found></app-not-found>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-12">
        <ngb-pagination class="d-flex justify-content-center"
                        [maxSize]="10"
                        [rotate]="true"
                        [ellipses]="false"
                        [boundaryLinks]="true"
                        [page]="pageData?.number + 1"
                        (pageChange)="search($event)"
                        [pageSize]="pageData?.size"
                        [collectionSize]="pageData?.totalElements"></ngb-pagination>
      </div>
    </div>
  </div>
</div>
